import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Clickable from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import styled, { css } from "styled-components";


const enum fields {
    leftPadding = "leftPadding",
    topPadding = "topPadding",
}
interface OwnProps extends WidgetProps {
    fields: {
        [fields.leftPadding]: number;
        [fields.topPadding]: number;
    };
}

interface Props extends OwnProps, HasCategoryContext {}

export interface CategoryDetailBannerStyles {
    container?: InjectableCss;
    readMoreLink?: InjectableCss;
    hideContent?: InjectableCss;
    showContent?: InjectableCss;
    lessContent?: InjectableCss;
    readMoreLinkWrapper?: InjectableCss;
}

export const bannerStyles: CategoryDetailBannerStyles = {
    container: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            // padding-top: 30px;
                           // padding-left: 0px !important;
                        `,
                        css`
                            // padding-top: 30px;
                          //  padding-left:0px !important;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    showContent: {
        css: css`
            height: auto;
            transition: all 0.4s ease;
            body {
                background: transparent;
            }
        `,
    },
    hideContent: {
        css: css`
            height: 111px;
            transition: all 0.4s ease;
            overflow: hidden;
            body {
                background: transparent;
            }
        `,
    },
    lessContent: {
        css: css`
            height: auto;
            transition: all 0.4s ease;
            body {
                background: transparent;
            }
        `,
    },
    readMoreLinkWrapper: {
        css: css`
            color: #ef3742;
            display: flex;
            justify-content: flex-start;
            margin-top: 5px;
            margin-bottom: 15px;
        `,
    },
    readMoreLink: {
        css: css`
            color: #ef3742;
            &:hover {
                text-decoration: underline;
            }
        `,
    },
};

const styles = bannerStyles;
const CategoryDetailBanner = ({ category }: Props) => {
    if (!category || !category.htmlContent) {
        return null;
    }
    const DivStyle = styled.div`
        padding-left: ${fields.leftPadding}px;
        padding-top: ${fields.topPadding}px;
    `;

    const [readMore, setReadMore] = React.useState(false);
    const [currentDeviceWidth, setCurrentDeviceWidth] = React.useState(1366);
    useEffect(() => {
        setCurrentDeviceWidth(window.screen.width);
        const handleResize = () => {
            setCurrentDeviceWidth(window.screen.width);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    });

    const isCount =
        currentDeviceWidth > 1024 // desktop
            ? category.htmlContent.length > 920
            : currentDeviceWidth === 1024 // Ipad pro
            ? category.htmlContent.length > 820
            : currentDeviceWidth >= 768 && currentDeviceWidth < 1024 // ipad
            ? category.htmlContent.length > 640
            : currentDeviceWidth >= 425 && currentDeviceWidth < 768 // iphoneX
            ? category.htmlContent.length > 440
            : currentDeviceWidth >= 375 && currentDeviceWidth < 425 // iphone 6/7/8 Plus
            ? category.htmlContent.length > 340
            : currentDeviceWidth >= 320 && currentDeviceWidth < 375 // iphone 5/6/7/8
            ? category.htmlContent.length > 340
            : currentDeviceWidth >= 0 && currentDeviceWidth < 320 // lower than iphone 5 Devices
            ? category.htmlContent.length > 240
            : false;
    return (
        <StyledWrapper {...styles.container}>
            <DivStyle>
                <StyledWrapper
                    {...(isCount
                        ? readMore
                            ? { ...styles.showContent }
                            : { ...styles.hideContent }
                        : { ...styles.lessContent })}
                    id="categoryDesc"
                >
                    {parse(category.htmlContent, parserOptions)}
                </StyledWrapper>
                <StyledWrapper {...styles.readMoreLinkWrapper}>
                    <Clickable
                        {...styles.readMoreLink}
                        key="readMore"
                        onClick={() => setReadMore(!readMore)}
                        data-test-selector="readMoreContent"
                    >
                        {isCount ? (readMore ? "Read Less" : "Read More") : ""}
                    </Clickable>
                </StyledWrapper>
            </DivStyle>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withCategory(CategoryDetailBanner),
    definition: {
        group: "Category Details",
        icon: "image-landscape",
        allowedContexts: ["CategoryDetailsPage", "ProductListPage"],
        fieldDefinitions: [
            {
                name: fields.leftPadding,
                displayName: "Left Padding",
                editorTemplate: "IntegerField",
                defaultValue: 0,
                fieldType: "General",
                max: 100,
                min: 0,
            },
            {
                name: fields.topPadding,
                displayName: "Top Padding",
                editorTemplate: "IntegerField",
                defaultValue: 0,
                fieldType: "General",
                max: 100,
                min: 0,
            },
        ],
    },
};

export default widgetModule;
